import { productFaqBySpuId, productDetailData, productDwonloads } from '@/service/product';

export const getProductMsg = async (locale: string, promsg: any) => {
    try {
        const [detailRes, faqRes, downloadsRes, videosRes, onlinesRes] = await Promise.all([
            productDetailData({ handle: promsg.url }, locale || 'us'),
            productFaqBySpuId({ spuId: promsg.sourceId }, locale || 'us'),
            productDwonloads({ spuIds: promsg.sourceId }, locale || 'us'),
            productDwonloads({ spuIds: promsg.sourceId, classify: 'VIDEO_COURSE' }, locale || 'us'),
            productDwonloads({ spuIds: promsg.sourceId, classify: 'ONLINE' }, locale || 'us'),
        ]);

        const data1 = detailRes.data || {};
        const data2 = faqRes.data?.records || [];
        const data3 = downloadsRes?.data?.content || [];
        const data4 = videosRes?.data?.content || [];
        const data5 = onlinesRes?.data?.content || [];

        return {
            resProductCatagory: data1.productCatagoryResponseList,
            productDetail: data1.spuResponse,
            supportData: {
                faqList: data2,
                downloadList: data3,
                videoList: data4,
                onlineList: data5,
            },
        };
    } catch (error) {
        console.error(error);
    }
};

export const getProductData = async (productName: string, locale: string, callback: any) => {
    const resData = await productDetailData({ handle: productName }, locale || 'us');
    const faqRes = await productFaqBySpuId({ spuId: resData?.data?.spuResponse?.seoPage?.sourceId }, locale);
    const faqList = faqRes.data?.records || [];

    const data = {
        resProductCatagory: resData?.data?.productCatagoryResponseList || [],
        productDetail: resData?.data?.spuResponse || {},
        faqList: faqList || [],
    };
    callback && callback(data.resProductCatagory, data.productDetail, data.faqList);
    return data;
};

export const getProductRiver2Data = async (productName: string, locale: string) => {
    const resData = await productDetailData({ handle: productName }, locale || 'us');
    const faqRes = await productFaqBySpuId({ spuId: resData?.data?.spuResponse?.seoPage?.sourceId }, locale);
    const resDataRiver2Max = await productDetailData({ handle: 'river-2-max-portable-power-station' }, locale || 'us');
    const resDataRiver2Pro = await productDetailData({ handle: 'river-2-pro-portable-power-station' }, locale || 'us');
    const faqList = faqRes.data?.records || [];

    const data = {
        resProductCatagory: resData?.data?.productCatagoryResponseList || [],
        productDetail: resData?.data?.spuResponse || {},
        resDataRiver2Max: resDataRiver2Max,
        resDataRiver2Pro: resDataRiver2Pro,
        faqList: faqList || [],
    };
    return data;
};

export const getProductFromGeneralKey = ({ gloproductlist, generalKey }: { gloproductlist: any[]; generalKey: string }) => {
    const arr = gloproductlist?.filter((item) => item.generalKey === generalKey);
    return (arr && arr[0]) || {};
};

export const getServerSidePropsUtil = (productName: string) => {
    return async ({ locale }) => {
        let resData = null;
        let faqList = null;

        try {
            resData = await productDetailData({ handle: productName }, locale || 'us');
            const faqRes = await productFaqBySpuId({ spuId: resData?.data?.spuResponse?.seoPage?.sourceId }, locale);
            faqList = faqRes.data?.records || [];
        } catch (e) {
            console.log('e', e);
        }

        return {
            props: {
                resProductCatagory: resData?.data?.productCatagoryResponseList || [],
                productDetail: resData?.data?.spuResponse || null,
                faqList: faqList,
            },
        };
    };
};
